import { rem } from 'polished';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Modal } from '@vimeo/iris/components';
import { DismissX } from '@vimeo/iris/icons';

type Props = {
  open?: boolean;
  modalHeader: string;
  onClose: VoidFunction;
};

type State = {
  open?: boolean;
};

class ContentModal extends React.Component<Props & PropsWithChildren, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: this.props.open || false,
    };
  }

  render() {
    const { modalHeader } = this.props;

    // State coming from props always has the right of way
    if (this.props.open !== undefined && this.props.open !== this.state.open) {
      this.setState({ open: this.props.open });
    }

    return (
      <StyledModal
        onClose={this._handleCloseClick}
        active={this.state.open}
        content={
          <ModalStyled>
            <DismissIcon onClick={this._handleCloseClick} />
            <Modal.Header>{modalHeader}</Modal.Header>
            {this.props.children}
          </ModalStyled>
        }
      />
    );
  }

  _handleCloseClick = () => {
    if (this.props.open !== undefined) {
      if (typeof this.props.onClose === 'function') {
        this.props.onClose();
      }
    } else {
      this.setState({ open: false });
    }
  };
}

export default ContentModal;

const StyledModal = styled(Modal)`
  background: ${({ theme }) => theme.content.background};
  overflow: auto;
  transition: all 0.5s;

  max-width: ${rem(340)};
  width: ${rem(349)};

  @media (min-width: 480px) {
    max-width: ${rem(440)};
    width: ${rem(440)};
  }

  @media (min-width: 780px) {
    max-width: ${rem(660)};
    width: ${rem(660)};
  }
`;

const ModalStyled = styled.div`
  position: relative;
  padding: ${rem(32)};
  border-radius: ${rem(4)};
  background: ${({ theme }) => theme.content.background};
`;

const DismissIcon = styled(DismissX)`
  position: absolute;
  top: ${rem(18)};
  right: ${rem(18)};
  width: ${rem(20)};
  height: ${rem(20)};
  z-index: 1;
  cursor: pointer;

  fill {
    color: ${({ theme }) => theme.content.color};
  }

  &:hover {
    width: ${rem(22)};
    height: ${rem(22)};
    top: ${rem(17)};
    right: ${rem(17)};
  }
`;
